import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/** Icon-only Button (MUI-`IconButton`-Ersatz) auf `.sec-icon-btn`-Basis. */
export const IconButton = forwardRef(function IconButton({ type = 'button', size = 'md', className, ...rest }, ref) {
    return (_jsx("button", { ref: ref, type: type, className: cn('sec-icon-btn', size === 'sm' && 'sec-icon-btn--sm', className), ...rest }));
});
